<ng-container *ngIf="initialized;else loading">
    <nb-accordion multi kwExpandFirstItem>
        <nb-accordion-item [expanded]="!isCustom">
            <nb-accordion-item-header>{{themeField?.title}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <kve-field-editor [field]="themeField" (updateField)="onFieldUpdate($event)"></kve-field-editor>
            </nb-accordion-item-body>
        </nb-accordion-item>
        <nb-accordion-item expanded>
            <nb-accordion-item-header>{{customField?.title}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <kve-field-editor [field]="customField" (updateField)="onFieldUpdate($event)" #toggleCustom></kve-field-editor>
            </nb-accordion-item-body>
        </nb-accordion-item>
        <nb-accordion-item *ngIf="isCustom" expanded>
            <nb-accordion-item-header>{{backgroundField?.title}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <kve-field-editor [field]="backgroundField" (updateField)="onFieldUpdate($event)"></kve-field-editor>
            </nb-accordion-item-body>
        </nb-accordion-item>
        <nb-accordion-item *ngIf="isCustom" expanded>
            <nb-accordion-item-header>{{textColorField?.title}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <kve-field-editor [field]="textColorField" (updateField)="onFieldUpdate($event)"></kve-field-editor>
            </nb-accordion-item-body>
        </nb-accordion-item>
    <!--     <nb-accordion-item *ngFor="let field of fields;let i = index" [expanded]="i == '0'">
            <nb-accordion-item-header>{{field?.title}}</nb-accordion-item-header>
            <nb-accordion-item-body>
                <kve-field-editor [field]="field" (updateField)="onFieldUpdate($event)"></kve-field-editor>
            </nb-accordion-item-body>
        </nb-accordion-item> -->
    </nb-accordion>
</ng-container>
<ng-template #loading>
    <p>loading</p>
</ng-template>


